import React from "react";
import { Box, Typography } from "@mui/material";
import { Tooltip } from "../../../../../components";
import { colors } from "../../config";

interface PriceBadgeProps {
  label: string;
  color: "green" | "red" | "default";
  tooltip: string;
  onSelect?: (value: number) => void;
}

export default function PriceBadge({
  label,
  color,
  onSelect,
  tooltip,
}: PriceBadgeProps) {
  const style =
    color === "green"
      ? {
          bg: colors.success.background,
          border: `1px solid ${colors.success.border}`,
          textColor: colors.success.text,
          prefixColor: colors.text.primary,
        }
      : color === "red"
      ? {
          bg: colors.error.background,
          border: `1px solid ${colors.error.border}`,
          textColor: colors.error.text,
          prefixColor: colors.text.primary,
        }
      : {
          bg: colors.background.gray,
          border: `1px solid ${colors.border.medium}`,
          textColor: colors.text.secondary,
          prefixColor: colors.text.secondary,
        };

  const dollarIndex = label.indexOf("$");
  const prefix = dollarIndex !== -1 ? label.substring(0, dollarIndex) : "";
  const price = dollarIndex !== -1 ? label.substring(dollarIndex) : label;
  const handlePriceValue = () => {
    if (!onSelect) return;
    const numeric = Number(price.replace(/[^0-9.]/g, ""));
    onSelect(numeric);
  };

  return (
    <Tooltip title={tooltip}>
      <Box
        padding="4px"
        bgcolor={style.bg}
        border={style.border}
        borderRadius="6px"
        display="flex"
        alignItems="center"
        height="23px"
      >
        {prefix && (
          <Typography
            fontSize="12px"
            fontWeight={500}
            color={style.prefixColor}
            lineHeight="15px"
          >
            {prefix}&nbsp;
          </Typography>
        )}
        <Typography
          fontSize="12px"
          fontWeight={500}
          color={style.textColor}
          lineHeight="15px"
          onClick={handlePriceValue}
          sx={{ cursor: "pointer" }}
        >
          {price}
        </Typography>
      </Box>
    </Tooltip>
  );
}
